// extracted by mini-css-extract-plugin
export default {"centered":"magic-link_centered__lu1XK"};